export const findGroupByAreasIds = (groups, areasIds) => {
    return groups.find(group => group.areas.some(id => areasIds.includes(id)));
};
